import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function RouteChangeHandler() {
  const location = useLocation();
  const NAMESPACE_OPTUM_REACTOR = process.env.REACT_APP_NAMESPACE_OPTUM_REACTOR;

  useEffect(() => {
    if (location.pathname.length > 1) {   
      const custom_data_object = {"namespace": NAMESPACE_OPTUM_REACTOR, "application_viewUrl": location.pathname}
      if (typeof window !== 'undefined' && window.hasOwnProperty("Rakanto") && window.Rakanto.hasOwnProperty('event')) {
        window.Rakanto.event("sendCustomData", custom_data_object);
        window.Rakanto.event('viewLoaded');
      }
    }
  }, [location]);
  return null;
}

export default RouteChangeHandler;
